import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'app-custom-checkbox',
    template: `
    <div class="custom-checkbox cursor-pointer" (click)="toggleCheckbox()" style='padding:8px'>
      <div class="checkbox-container cursor-pointer" [ngClass]="{ 'checked': formControl.value }">
        <div class="checkbox-box cursor-pointer">
          <div class="checkmark" *ngIf="formControl.value">
            <div class="checkmark-stem"></div>
            <div class="checkmark-kick"></div>
          </div>
        </div>
        <label class="cursor-pointer">{{ to.label }}</label>
      </div>
    </div>
  `,
  styles: [`
    .custom-checkbox {
      cursor: pointer;
    }
  
    .checkbox-container {
      display: flex;
      align-items: center;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      padding: 16px;
      transition: border-color 0.3s ease, background-color 0.3s ease, color 0.3s ease;
      height: 52px;
      width: 100%;
    }
  
    /* Hover effect */
    .checkbox-container:hover {
      //background-color: #D47500;
      border-color:#666564;
      //color: white;
    }
  
    .checkbox-container:hover label {
      //color: white;
    }
  
    .checkbox-container:hover .checkbox-box {
      //border-color: white;
    }
    
  
    .checkbox-box {
      width: 20px;
      height: 20px;
      border: 2px solid #d0d5dd;
      border-radius: 4px;
      background-color: #fff;
      position: relative;
      flex-shrink: 0;
      margin-right: 10px;
      transition: border-color 0.3s ease, background-color 0.3s ease;
    }
  
    .checkbox-box .checkmark {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
      height: 10px;
      border-bottom: 2px solid #fff;
      border-right: 2px solid #fff;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
  
    .checkbox-container.checked .checkbox-box {
      background-color: #FFC680;
      border-color: #FFC680;
    }
  
    .checkbox-container.checked label {
      color: #AA5D00;
    }
    /* Base checked style */
    .checkbox-container.checked {
  background-color: #FFF1E0;
  border-color: #FFF1E0;
  color: #AA5D00;
    }

    /* Hover + Checked together */
//   .checkbox-container.checked:hover {
//   background-color: #D47500;
//   border-color: #D47500;
//   color: black;
//     }

//   .checkbox-container.checked:hover label {
//   color: black;
//   } 

// .checkbox-container.checked:hover .checkbox-box {
//   background-color: #D47500;
//   border-color: white;
// }

// .checkbox-container.checked:hover .checkmark-stem,
// .checkbox-container.checked:hover .checkmark-kick {
//   background-color: #D47500;
// }

`]
  
})
export class CustomCheckboxComponent extends FieldType {
    toggleCheckbox() {
        const newValue = !this.formControl.value;
        this.formControl.patchValue(newValue);
    }
}
